export default {"src":"/_next/static/media/certifiedType.394e65e6.svg","height":22,"width":15,"blurWidth":0,"blurHeight":0};